import { userUsesNewUiEligible } from '@utils/userUsesNewUiEligible'

/**
 * RepuAgency premium only — per-customer Business Limits are not a mini-app feature.
 * @param {Object|null|undefined} user
 * @returns {boolean}
 */
export function userHasRepuAgencyBusinessLimits(user) {
  if (!user) {
    return false
  }

  return !!(
    user.has_premium_plan ||
    user.has_repu_agency ||
    userUsesNewUiEligible(user)
  )
}

/**
 * Whether Business Limits apply for the logged-in user (agency owner or business under RepuAgency).
 * @param {Object|null|undefined} user
 * @returns {boolean}
 */
export function businessLimitsEnabledForUser(user) {
  if (!user) {
    return false
  }

  if (user.role === 'Admin' || localStorage.getItem('main_access_role') === 'Admin') {
    return true
  }

  if (user.role === 'Agency') {
    return userHasRepuAgencyBusinessLimits(user)
  }

  if (user.role === 'Business') {
    return userHasRepuAgencyBusinessLimits(user.business?.owner)
  }

  return false
}

/**
 * @param {Object|null|undefined} user
 * @param {string} key
 * @returns {number|null} null when limits are disabled or unset (no cap)
 */
export function businessLimitForUser(user, key) {
  if (!businessLimitsEnabledForUser(user)) {
    return null
  }

  const value = user?.business?.limits?.[key]
  if (value == null || value === 0) {
    return null
  }

  return value
}
